










































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import ConfirmDialog from '@/components/dialogs/ConfirmDialog.vue';
import TableCellChips from '@/components/TableCellChips.vue';
import {
  Groups,
  User,
  Global,
  MapSettings,
  Schedules,
  Props
} from '@/store';
import cloneDeep from 'lodash/cloneDeep';

@Component({
  components: { ConfirmDialog, TableCellChips }
})
class GroupsList extends Vue {
  @User.State('project') project;
  @Groups.State('list') groups;
  @Groups.Action('remove') removeGroup;
  @Global.State('readonly_user') readonly_user;
  @Global.State('notify') notify;
  @Global.State('lang') lang;
  @Global.Mutation('setPageTitle') setPageTitle;
  @MapSettings.State('userMapFilters') userMapFilters;
  @MapSettings.Action('updateFiltersProperty') updateFiltersProperty;
  @MapSettings.Mutation('setUserMapFilters') setUserMapFilters;
  @Schedules.Action('loadSchedules') loadSchedules;
  @Schedules.State('schedules') schedules;
  @Schedules.Action('runSchedulerInServer') runSchedulerInServer;
  @Props.Action('editProp') edit;
  @Props.State('list') projectProperties;
  @Props.Action('load') loadProjectProperties;

  isLoading = true;
  loadingDelete = false;
  deleteDialog = false;
  groupData = {};
  pagination = { sortBy: 'date', descending: true, rowsPerPage: 10 };
  localFilters = [];
  localSchedules = [];
  currentGroups = null;
  checkbox_color = '#812E81';
  search = '';
  schedule_filter = [];

  async mounted() {
    this.setPageTitle('Group Management');
    this.isLoading = true;
    this.currentGroups = this.groups;
    // The schedules column and filter both read off the schedules property, which
    // this page only used to load lazily when a group was deleted.
    if (this.project) await this.loadSchedules({ projectId: this.project.id });
    this.isLoading = false;
  }

  get headers() {
    return [
      {
        text: 'Name',
        value: 'name'
      },
      {
        text: 'Assigned devices',
        value: 'devices'
      },
      {
        text: 'Schedules',
        value: 'schedules',
        sortable: false
      },
      {
        text: 'Description',
        value: 'description'
      },
      {
        text: 'Actions',
        value: 'id',
        sortable: false
      }
    ];
  }

  /**
   * Group id -> the schedules applied to it, name sorted, so a chip can link to one and
   * the filter can match on ids. The assignment only lives on the schedule side
   * (schedule.groups holds group ids), so it has to be reversed here.
   */
  get group_schedules_map() {
    const map = {};
    (this.currentGroups || []).forEach((group) => map[group.id] = []);

    (this.schedules || []).forEach((schedule) => {
      if (!Array.isArray(schedule.groups)) return;
      schedule.groups.forEach((group_id) => {
        if (map[group_id]) map[group_id].push({ id: schedule.id, name: schedule.name });
      });
    });

    Object.keys(map).forEach((group_id) =>
      map[group_id].sort((schedule1, schedule2) => `${schedule1.name}`.localeCompare(`${schedule2.name}`)));

    return map;
  }

  /** Only schedules actually applied to a group are worth filtering by. */
  get filter_schedules_list() {
    return (this.schedules || [])
      .filter((schedule) => Array.isArray(schedule.groups) && schedule.groups.length)
      .map((schedule) => ({ id: schedule.id, name: schedule.name }))
      .sort((schedule1, schedule2) => `${schedule1.name}`.localeCompare(`${schedule2.name}`));
  }

  /** Start edge of a row, which swaps with the language direction. */
  get start_align_class() {
    return this.lang === 'en' ? 'text-xs-left' : 'text-xs-right';
  }

  /*
    Whether the project has any groups at all, which is what the empty state answers -
    `filtered_groups` being empty can also just mean the filters excluded everything.
  */
  get has_groups() {
    return (this.currentGroups || []).length > 0;
  }

  get is_filtering() {
    return !!(this.search || '').trim() || this.schedule_filter.length > 0;
  }

  get filtered_groups() {
    const query = (this.search || '').trim().toLowerCase();
    if (!this.is_filtering) return this.currentGroups || [];

    return (this.currentGroups || []).filter((group) => {
      const matches_search = !query || `${group.name || ''}`.toLowerCase().includes(query);
      const group_schedules = this.group_schedules_map[group.id] || [];
      const matches_schedules = !this.schedule_filter.length ||
        group_schedules.some((schedule) => this.schedule_filter.includes(schedule.id));

      return matches_search && matches_schedules;
    });
  }

  clearFilters() {
    this.search = '';
    this.schedule_filter = [];
  }

  @Watch('pagination')
  watchPagination() {
    if (this.pagination.sortBy === 'devices') {
      if (this.pagination.descending) {
        this.currentGroups.sort((a, b) => a.total_devices > b.total_devices ? 1 : -1);
      } else {
        this.currentGroups.sort((a, b) => a.total_devices > b.total_devices ? -1 : 1);
      }
    }
  }

  @Watch('project')
  async reloadSchedules() {
    if (!this.project) return;
    this.clearFilters();
    await this.loadSchedules({ projectId: this.project.id });
  }

  @Watch('$store.state.Groups.list')
  async setGroups() {
    if (this.groups.length > 0) {
      this.currentGroups = this.groups;
    }
  }

  async removeGroupAction() {
    this.loadingDelete = true;
    await this.removeGroupFromFilters();
    // if (this.notify && this.notify.type === 'error') {
    //   this.loadingDelete = false;
    //   this.deleteDialog = false;
    //   return;
    // }

    await this.removeGroupFromSchedules();
    // if (this.notify && this.notify.type === 'error') {
    //   await this.updateFilters(this.localFilters);
    //   this.loadingDelete = false;
    //   this.deleteDialog = false;
    //   return;
    // }
    await this.removeGroup(this.groupData);
    // if (this.notify && this.notify.type === 'error'){
    //   await this.updateFilters(this.localFilters);
    //   await this.updateSchedules(this.localSchedules);
    //   this.loadingDelete = false;
    //   this.deleteDialog = false;
    //   return;
    // }

    this.loadSchedules();
    this.loadProjectProperties({ projectId: this.project.id });
    this.runSchedulerInServer();

    this.loadingDelete = false;
    this.deleteDialog = false;
  }

  async removeGroupFromFilters() {
    this.localFilters = cloneDeep(this.userMapFilters);
    const new_filters = this.userMapFilters
      .filter((filter) => filter.name !== 'default')
      .map((filter) => {
        if (filter.groups.includes(this.groupData['groupID'])) {
          if (filter.groups.length === 1) return null;
          return {
            ...filter,
            groups: filter.groups.filter(
              (group_id) => group_id !== this.groupData['groupID']
            )
          };
        }
        return filter;
      })
      .filter((filter) => filter);

    await this.updateFilters(new_filters);
  }

  async updateFilters(filters) {
    const filters_data = {
      projectId: this.project.id,
      routes: filters
    };
    await this.updateFiltersProperty(filters_data);
  }

  async removeGroupFromSchedules() {
    if (!this.schedules.length)
      await this.loadSchedules({ projectId: this.project.id });
    this.localSchedules = cloneDeep(this.schedules);
    const new_schedules = this.schedules
      .map((schedule) => {
        if (
          schedule.groups &&
          schedule.groups.length &&
          schedule.groups.includes(this.groupData['groupID'])
        ) {
          if (schedule.groups.length === 1) return null;
          return {
            ...schedule,
            groups: schedule.groups.filter(
              (group_id) => group_id !== this.groupData['groupID']
            )
          };
        }
        return schedule;
      })
      .filter((schedule) => schedule);
    await this.updateSchedules(new_schedules);
  }

  async updateSchedules(schedules) {
    await this.edit({
      objectType: 'projects',
      objectID: this.project.id,
      name: 'dashboard.schedules',
      value: schedules
    });
  }

  deleteGroup(groupID, groupName) {
    if (groupID) {
      const data = {
        projectID: this.project.id,
        groupID,
        groupName
      };
      this.deleteDialog = true;
      this.groupData = data;
    }
  }
}

export default GroupsList;
